// src/session.js
export default {
    install(app) {
      // Define a simple session object to store data
      const session = {
        data: {},
        start() {
          this.data = {}; // Initialize or reset session data
        },
        set(key, value) {
          this.data[key] = value;
        },
        get(key) {
          return this.data[key];
        },
        remove(key) {
          delete this.data[key];
        },
        exists(key) {
          delete this.data[key];
        },
        clear() {
          this.data = {};
        },
      };
  
      // Make the session object globally accessible
      app.config.globalProperties.$session = session;
    },
  };
  